import {
  apiValidateCampaignToken,
  apiCheckCampaignUsage,
  apiRegisterCampaignUsage,
} from '../../services/Campaign'
import {
  CAMPAIGN_VALIDATE_LOADING,
  CAMPAIGN_VALIDATE_SUCCESS,
  CAMPAIGN_VALIDATE_FAIL,
  CAMPAIGN_CHECK_USAGE_LOADING,
  CAMPAIGN_CHECK_USAGE_SUCCESS,
  CAMPAIGN_CHECK_USAGE_FAIL,
  CAMPAIGN_REGISTER_USAGE_LOADING,
  CAMPAIGN_REGISTER_USAGE_SUCCESS,
  CAMPAIGN_REGISTER_USAGE_FAIL,
  CAMPAIGN_RESET,
} from '../reducers/CampaignReducer'

export const _CAMPAIGN_VALIDATE_LOADING = () => ({
  type: CAMPAIGN_VALIDATE_LOADING,
})

export const _CAMPAIGN_VALIDATE_SUCCESS = (token, data) => ({
  type: CAMPAIGN_VALIDATE_SUCCESS,
  payload: { token, data },
})

export const _CAMPAIGN_VALIDATE_FAIL = (error) => ({
  type: CAMPAIGN_VALIDATE_FAIL,
  payload: { error },
})

export const _CAMPAIGN_CHECK_USAGE_LOADING = () => ({
  type: CAMPAIGN_CHECK_USAGE_LOADING,
})

export const _CAMPAIGN_CHECK_USAGE_SUCCESS = (data) => ({
  type: CAMPAIGN_CHECK_USAGE_SUCCESS,
  payload: { data },
})

export const _CAMPAIGN_CHECK_USAGE_FAIL = (error) => ({
  type: CAMPAIGN_CHECK_USAGE_FAIL,
  payload: { error },
})

export const _CAMPAIGN_REGISTER_USAGE_LOADING = () => ({
  type: CAMPAIGN_REGISTER_USAGE_LOADING,
})

export const _CAMPAIGN_REGISTER_USAGE_SUCCESS = (data) => ({
  type: CAMPAIGN_REGISTER_USAGE_SUCCESS,
  payload: { data },
})

export const _CAMPAIGN_REGISTER_USAGE_FAIL = (error) => ({
  type: CAMPAIGN_REGISTER_USAGE_FAIL,
  payload: { error },
})

export const _CAMPAIGN_RESET = () => ({
  type: CAMPAIGN_RESET,
})

export const validateCampaignTokenAction = (token) => (dispatch) => {
  dispatch(_CAMPAIGN_VALIDATE_LOADING())
  apiValidateCampaignToken(token)
    .then((res) => {
      console.log('[validateCampaignToken] res.data:', res.data)
      if (!res.data.success) {
        return dispatch(_CAMPAIGN_VALIDATE_FAIL(res.data.error || 'Token inválido'))
      }
      dispatch(_CAMPAIGN_VALIDATE_SUCCESS(token, res.data.data))
    })
    .catch((error) => {
      console.error('Error validating campaign token:', error)
      dispatch(
        _CAMPAIGN_VALIDATE_FAIL(
          error?.response?.data?.error || error?.message || 'Error al validar token'
        )
      )
    })
}

export const checkCampaignUsageAction = (dni, token) => (dispatch) => {
  dispatch(_CAMPAIGN_CHECK_USAGE_LOADING())
  apiCheckCampaignUsage(dni, token)
    .then((res) => {
      if (!res.data.success) {
        return dispatch(_CAMPAIGN_CHECK_USAGE_FAIL(res.data.error || 'Error al verificar uso'))
      }
      dispatch(_CAMPAIGN_CHECK_USAGE_SUCCESS(res.data.data))
    })
    .catch((error) => {
      console.error('Error checking campaign usage:', error)
      dispatch(
        _CAMPAIGN_CHECK_USAGE_FAIL(
          error?.response?.data?.error || error?.message || 'Error al verificar uso'
        )
      )
    })
}

export const registerCampaignUsageAction = (dni, token) => (dispatch) => {
  dispatch(_CAMPAIGN_REGISTER_USAGE_LOADING())
  const data = {
    action: 'register-usage',
    dni: dni,
    token: token,
  }
  apiRegisterCampaignUsage(data)
    .then((res) => {
      if (!res.data.success) {
        console.error('Error registering campaign usage:', res.data.error)
        return dispatch(
          _CAMPAIGN_REGISTER_USAGE_FAIL(res.data.error || 'Error al registrar uso')
        )
      }
      console.log('Campaign usage registered successfully:', res.data.data)
      dispatch(_CAMPAIGN_REGISTER_USAGE_SUCCESS(res.data.data))
    })
    .catch((error) => {
      console.error('Error registering campaign usage:', error)
      dispatch(
        _CAMPAIGN_REGISTER_USAGE_FAIL(
          error?.response?.data?.error || error?.message || 'Error al registrar uso'
        )
      )
    })
}
